import { render } from "./AddButton.vue?vue&type=template&id=2ed0b670"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"
script.render = render

export default script